<div class="d-flex flex-wrap">
    <div class="mr-3 mb-3">
            <input [(ngModel)]="filterText"
            name="filterText"
            (keyup.enter)="refresh()"
            (blur)="refresh()"
            autoFocus
            class="form-control m-input"
            [placeholder]="l('SearchNameWithThreeDot')"
            type="text">
    </div>
    <div class="select-personal-align">
        <div class="mr-3 mb-3">
            <button class="btn btn-default btn-inverted" (click)="locationSelector.open()">
                {{ l("Location") }}
            </button>
            
            <div class="locationSelector">
                <mat-form-field>
                    <mat-select [formControl]="locationFormCtrl" [multiple]="false" #locationSelector>
                        <mat-option>
                            <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                placeholderLabel="Find a location..." [formControl]="locationFilterFormCtrl">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let location of filteredLocation | async" [value]="location" (click)="refresh()"
                            #option>
                            {{ location.locationName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="mr-3 mb-3">
            <button class="btn btn-default btn-inverted" (click)="companySelector.open()">
                {{ l("Company") }}
            </button>

            <div class="locationSelector">
                <mat-form-field>
                    <mat-select [formControl]="companyFormCtrl" [multiple]="false" #companySelector>
                        <mat-option>
                            <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                placeholderLabel="Find a company..." [formControl]="companyFilterFormCtrl">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let company of filteredCompany | async" [value]="company" (click)="refresh()"
                            #option>
                            {{ company.company }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!-- <div class="mr-3 mb-3">
            <button class="btn btn-default btn-inverted" (click)="tradeSelector.open()">
                {{ l("Trade") }}
            </button>

            <div class="locationSelector">
                <mat-form-field>
                    <mat-select [formControl]="tradeFormCtrl" [multiple]="false" #tradeSelector>
                        <mat-option>
                            <ngx-mat-select-search noEntriesFoundLabel="No results found" placeholderLabel="Find a trade..."
                                [formControl]="tradeFilterFormCtrl">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let trade of filteredTrade | async" [value]="trade" (click)="refresh()" #option>
                            {{ trade.trade }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div> -->
        <div class="mr-3 mb-3">
            <button class="btn btn-link link-grey" (click)="clear()">
                {{ l("Clear") }}
            </button>
        </div>
    </div>
</div>
<div class="d-flex flex-wrap filter" *ngIf='filterText 
    || (locationFormCtrl.value && locationFormCtrl.value.locationName) || 
    (companyFormCtrl.value && companyFormCtrl.value.company)'>
    {{ l("Filter") }}: 
    <ng-container *ngIf='filterText'> {{ l("Search") }} - {{filterText}},</ng-container>
    <ng-container *ngIf='locationFormCtrl.value && locationFormCtrl.value.locationName'> {{ l("Location") }} - {{locationFormCtrl.value.locationName}},</ng-container>
    <ng-container *ngIf='companyFormCtrl.value && companyFormCtrl.value.company'> {{ l("Company") }} - {{companyFormCtrl.value.company}},</ng-container>
</div>